import moment from 'moment';
import angular from 'angular';
import * as R from 'ramda';

export default function PRAIncompleteAssessmentController(
  $q,
  $rootScope,
  $scope,
  $filter,
  addPraAssessmentDialog,
  alerts,
  orgDataService,
  praDataService,
  loaderService,
  praBoardApproveDialog,
  confirmDialog,
  generatePRAReportDialog,
  bulkSubmitProcessesDialog,
  bulkApproveProcessesDialog,
  bulkResetProcessesDialog,
  ssDialogService,
  userService
) {
  const vm = this;

  vm.isExpanded = false;
  vm.handleExpandAssessment = _handleExpandAssessment;
  vm.handleEditAssessment = _handleEditAssessment;
  vm.handleGenerateReport = _handleGenerateReport;
  vm.handleBulkSubmitProcesses = _handleBulkSubmitProcesses;
  vm.handleBulkApproveProcesses = _handleBulkApproveProcesses;
  vm.handleBoardApprove = _handleBoardApprove;
  vm.handleBulkResetProcesses = _handleBulkResetProcesses;
  vm.handleDelete = _handleDelete;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();
    _initEventListeners();
    _initPermissions();
    _initStatuses(vm.assessment.status);
    _initCounts();

    dfdActivate.resolve();
  }

  function _initPermissions() {
    vm.canExpand = true;
    vm.canApprove = vm.canEditAssessment && vm.assessment.canBoardApprove;
    return userService.getUserPermissionSet('policyRiskAssessment').then((permissions) => {
      vm.permissions = permissions;
      vm.permissions.canApproveAssessment = vm.assessment.canBoardApprove;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshMainAssessment', () => {
      vm.isExpanded = false;
      vm.assessmentLoaded = false;
      refreshAssessment();
    });

    $scope.$on('refreshMainAssessmentProcess', () => {
      vm.isExpanded = false;
      vm.assessmentLoaded = false;
      refreshAssessment();
    });

    $scope.$on('setDocumentRegenerateFlag', () => {
      _setDocumentRegenerateFlag();
    });

    $scope.$on('refreshStatusesComplete', (event, status) => {
      _initStatuses(status);
    });

    $scope.$on('refreshOtherResourcesStatus', (event, opt) => {
      vm.assessment.status.otherResourcesStatus = opt.status;
      _initStatuses(vm.assessment.status);
    });
  }

  function _initStatuses() {
    vm.assessment.isOverdue = moment().isAfter(moment(vm.assessment.dueDate));
  }

  function _initCounts() {
      vm.counts = {
          notStartedProcessCount: 0,
          awaitingSubmissionProcessCount: 0,
          awaitingApprovalProcessCount: 0,
          completedProcessCount: 0,
          };
  
      angular.forEach(vm.assessment.assessmentProcesses, (process) => {
        if (process.status === 'NotStarted') {
          vm.counts.notStartedProcessCount += 1;
        } else if (process.status === 'InProgress') {
          vm.counts.awaitingSubmissionProcessCount += 1;
        } else if (process.status === 'AwaitingApproval') {
          vm.counts.awaitingApprovalProcessCount += 1;
        } if (process.status === 'Approved') {
          vm.counts.completedProcessCount += 1;
        }
      });
  }

  function _handleExpandAssessment() {
    if (!vm.assessmentLoaded) {
      getAssessment();
    } else {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleEditAssessment($event) {
    const _assessment = angular.copy(vm.assessment);
    ssDialogService.dialogs.pra.addAssessmentDialog = ssDialogService.alert(
      addPraAssessmentDialog.getOptions($event, {
        assessment: _assessment,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.pra.addAssessmentDialog);
  }

  function _handleGenerateReport($event) {
    praDataService.getAssessment(vm.assessment.assessmentId).then((response) => {
      loaderService.showViewLoader = false;
      ssDialogService.dialogs.pra.generatePRAReportDialog = ssDialogService.alert(
        generatePRAReportDialog.getOptions($event, {
          assessment: response.data,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.pra.generatePRAReportDialog);
    });
  }

  function _handleBulkSubmitProcesses($event) {
    let bulkSubmitProcesses = $filter('filter')(vm.assessment.assessmentProcesses, { status: 'InProgress' });

    ssDialogService.dialogs.pra.bulkSubmitProcessesDialog = ssDialogService.alert(
      bulkSubmitProcessesDialog.getOptions($event, {
        assessmentId: vm.assessment.assessmentId,
        processes: bulkSubmitProcesses,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pra.bulkSubmitProcessesDialog);
  }

  function _handleBulkApproveProcesses($event) {
    let bulkApproveProcesses = $filter('filter')(vm.assessment.assessmentProcesses, { status: 'AwaitingApproval' });
    
    ssDialogService.dialogs.pra.bulkApproveProcessesDialog = ssDialogService.alert(
      bulkApproveProcessesDialog.getOptions($event, {
        assessmentId: vm.assessment.assessmentId,
        processes: bulkApproveProcesses,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pra.bulkApproveProcessesDialog);
  }

  function _handleBulkResetProcesses($event) {
    let bulkResetProcesses = $filter('filter')(vm.assessment.assessmentProcesses, { status: 'Approved' });

    ssDialogService.dialogs.pra.bulkResetProcessesDialog = ssDialogService.alert(
      bulkResetProcessesDialog.getOptions($event, {
        assessmentId: vm.assessment.assessmentId,
        processes: bulkResetProcesses,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pra.bulkResetProcessesDialog);
  }

  function _handleBoardApprove($event) {
    vm.assessment.canBoardApprove = true;
    if (!vm.assessment.canBoardApprove) {
      alerts.error(
        'Can not Approve Assessment. Please approve / prioritize all processes and save latest '
        + 'finalized document before attempting board approval.'
      );
    } else {
      orgDataService.getSelectableUsers().then((response) => {
        ssDialogService.dialogs.pra.boardApproveDialog = ssDialogService.alert(
          praBoardApproveDialog.getOptions($event, {
            assessmentId: vm.assessment.assessmentId,
            assessmentName: vm.assessment.name,
            isNavantaUser: vm.isNavantaUser,
            users: response.data.result,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.pra.boardApproveDialog);
      });
    }
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.pra.deleteAssessmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Assessment?',
        message: `Are you sure you want to delete assessment "${vm.assessment.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pra.deleteAssessmentConfirmDialog);
  }

  function _handleConfirmDelete() {
    return praDataService.deleteAssessment(vm.assessment.assessmentId)
      .then(() => {
        alerts.success('The assessment has been deleted successfully.');
        $rootScope.$broadcast('refreshPRAAssessments');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting assessment.');
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pra.deleteAssessmentConfirmDialog);
  }

  function getAssessment() {
    loaderService.showViewLoader = true;
    praDataService.getAssessment(vm.assessment.assessmentId).then((response) => {
      vm.assessment = angular.copy(response.data);
      vm.assessment.informationTechnologyProcess = vm.assessment.assessmentProcesses.find(process => process.isManaged);
      vm.assessment.nonITProcesses = vm.assessment.assessmentProcesses.filter(process => !process.isManaged);
      vm.assessmentLoaded = true;
      loaderService.showViewLoader = false;
      vm.isExpanded = true;
    });
  }

  function refreshAssessment() {
    loaderService.showViewLoader = true;
    praDataService.getAssessment(vm.assessment.assessmentId).then((response) => {
      vm.assessment = angular.copy(response.data);
      vm.assessment.informationTechnologyProcess = vm.assessment.assessmentProcesses.find(process => process.isManaged);
      vm.assessment.nonITProcesses = vm.assessment.assessmentProcesses.filter(process => !process.isManaged);
    });
  }

  function _setDocumentRegenerateFlag() {
    if (vm.assessment.documentId > 0) {
      vm.assessment.regenerateDocument = true;
    }
  }
}

PRAIncompleteAssessmentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$filter',
  'addPraAssessmentDialog',
  'alerts',
  'orgDataService',
  'praDataService',
  'loaderService',
  'praBoardApproveDialog',
  'confirmDialog',
  'generatePRAReportDialog',
  'bulkSubmitProcessesDialog',
  'bulkApproveProcessesDialog',
  'bulkResetProcessesDialog',
  'ssDialogService',
  'userService'
];
